import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  z-index: 1000;
  left: ${({ theme }) => theme.paddings.xs};
  right: ${({ theme }) => theme.paddings.xs};
  bottom: ${({ theme }) => theme.paddings.xs};
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 25px;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  transition: opacity 0.6s ease, transform 0.6s ease;
  opacity: ${({ active }) => (active ? 1 : 0)};
  transform: translate3d(0, ${({ active }) => (active ? '0' : '30px')}, 0);
  pointer-events: ${({ active }) => (active ? 'auto' : 'none')};

  ${({ theme }) => theme.media.s} {
    left: auto;
    right: ${({ theme }) => theme.paddings.s};
    bottom: ${({ theme }) => theme.paddings.s};
    max-width: 440px;
  }

  ${({ theme }) => theme.media.m} {
    right: ${({ theme }) => theme.paddings.m};
    bottom: ${({ theme }) => theme.paddings.m};
  }
`

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;

  a {
    color: ${({ theme }) => theme.colors.purple};
    text-decoration: underline;
  }
`

export const Actions = styled.div`
  display: flex;
  gap: 10px;

  > button {
    flex: 1;
    margin: 0;
  }
`
